/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, shape,  string, func, arrayOf,
} from 'prop-types';
import { withRouter } from 'react-router';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import BackButton from '../../../common/BackButton';
import AccountLeftMenu from '../../../common/Desktop/AccountLeftMenu';
import { convertToYYYYMMDD, dateMMMMDDYYYY } from '../../../utils/dateString';

const styles = ({
    container: {
        width: '100%',
        maxWidth: '1440px',
        margin: 'auto',
    },
    listItem: {
        display: 'block',
        color: '#6c95e2', // TODO
        textDecoration: 'underline',
        lineHeight: '25px',
        cursor: 'pointer',
        paddingLeft: 20,
    },
    leftMenus: {
        textDecoration: 'none',
        listStyle: 'none',
        lineHeight: 1.5,
        marginTop: '50px',
    },
    arrowIcon: {
        verticalAlign: 'middle',
        fontSize: '16px',
    },
    alignCenter: {
        justifyContent: 'center',
    },
});

class DesktopPassport extends React.Component {
    componentDidMount = () => {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
    };

    errorPage = () => (
        <>
            <h1>
                <BackButton />
                Passport
            </h1>
            <div>
                Sorry! The data is not available at this time. Please try again
                later.
            </div>
        </>
    );

    handleListItemClicked = (url) => {
        const { history } =   this.props;
        history.push(url);
    };

    checkForPassportInCart = () => {
        let passportFound = false;
        const { cartData } = this.props;
        if (cartData?.orderDetails?.fdOrderVO) {
            const { recipients = [] } = cartData.orderDetails.fdOrderVO;
            recipients.forEach(({ orderItems = [] }) => {
                orderItems.forEach((orderItem) => {
                    if (orderItem.catalogEntryVO?.primeFreeShipFlag === 'M') {
                        passportFound = true;
                    }
                });
            });
        }
        return passportFound;
    }

    message = () => {
        const passportAdded = this.checkForPassportInCart();
        const { userProfile: { XAtt3 = '', XAtt5 = '' }  } = this.props;
        const today = new Date().getTime();
        // passport expiration date
        const expirationDate = new Date(XAtt5);
        // calculating time difference from today and expiration date
        const timeDifference = Math.abs(today - expirationDate);
        // calculating days difference from today and expiration date
        const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
        let msg = '';
        // calculating the new end date
        const newEndDate = dateMMMMDDYYYY(new Date(expirationDate.setFullYear(expirationDate.getFullYear() + 1)));
        if (XAtt3 !== '01-01' && daysDifference > 0 && daysDifference <= 60) {
            msg = `Your passport membership expired ${daysDifference} days ago`;
        } else if (passportAdded) {
            msg = `Passport has been added to your cart. Your new expiration date will be ${newEndDate} when you complete checkout`;
        }
        return msg;
    }

    handleCheckout = () => {
        const { history, orderData: { orderId } } = this.props;
        history.push(`/checkout/cart/${orderId}`);
    }

    render() {
        const {
            classes,
            userProfile,
            userProfile: {
                email, XAtt4, XAtt5,
            },
            featureFlags,
            handleSubscriptionRenewal,
        } = this.props;
        const passportAdded = this.checkForPassportInCart();
        if (!email || !XAtt4 || !XAtt5) return null;
        let startDate;
        let endDate;
        let memberSince;
        let renewalDate;
        let isActive = false;
        try {
            const XAtt4ToYYYYMMDD = convertToYYYYMMDD(XAtt4);
            const XAtt5ToYYYYMMDD = convertToYYYYMMDD(XAtt5);
            startDate = dateMMMMDDYYYY(XAtt4ToYYYYMMDD);
            endDate = dateMMMMDDYYYY(XAtt5ToYYYYMMDD);
            const startDateObj = new Date(XAtt4ToYYYYMMDD);
            const endDateObj = new Date(XAtt5ToYYYYMMDD);
            memberSince = startDateObj.getFullYear();
            renewalDate = dateMMMMDDYYYY(endDateObj, 0, 0, 1);
            isActive = new Date().getTime() < endDateObj.getTime();
        } catch (ex) {
            return this.errorPage();
        }
        return (
            <>
                <div className={classes.container}>
                    <Grid className="container" container>
                        <AccountLeftMenu
                            userProfile={userProfile}
                            featureFlags={featureFlags}
                        />
                        <Grid item xs={10}>
                            <h2>Passport </h2>
                            <Grid className="contentGrid" container item xs={12}>
                                <Grid className="block" item xs={12}>
                                    <div className="blockHeader">Membership Details </div>
                                </Grid>
                                <Grid className="blockContent no-margin-bottom" item xs={6}>
                                    <Grid container item xs={12} className="margin-bottom-2x">
                                        <Grid className="align-right" item xs={6}>
                                            <span className="gray-text spacing-right">Member Email:</span>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <span className="bold">{email}</span>
                                        </Grid>
                                    </Grid>

                                    <Grid container item xs={12} className="margin-bottom-2x">
                                        <Grid className="align-right" item xs={6}>
                                            <span className="gray-text spacing-right">Member Since:</span>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <span className="bold">{memberSince}</span>
                                        </Grid>
                                    </Grid>

                                    <Grid container item xs={12} className="margin-bottom-2x">
                                        <Grid className="align-right" item xs={6}>
                                            <span className="gray-text spacing-right">Membership Start Date:</span>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <span className="bold">{startDate}</span>
                                        </Grid>
                                    </Grid>

                                    <Grid container item xs={12} className="margin-bottom-2x">
                                        <Grid className="align-right" item xs={6}>
                                            <span className="gray-text spacing-right">Membership End Date:</span>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <span className="bold">{endDate}</span>
                                        </Grid>
                                    </Grid>

                                    <Grid container item xs={12} className="margin-bottom-2x">
                                        <Grid className="align-right" item xs={6}>
                                            <span className="gray-text spacing-right">Renewal Date:</span>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <span className="bold">{renewalDate}</span>
                                        </Grid>
                                    </Grid>
                                    <Grid container item xs={12} className="margin-bottom-2x">
                                        <Grid className="align-right" item xs={6}>
                                            <span className="gray-text spacing-right">Status:</span>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <span className="bold">{isActive ? 'Active' : 'Inactive'}</span>
                                        </Grid>
                                    </Grid>
                                    <Grid container item xs={12} className={classes.alignCenter}>
                                        <Grid className="align-center margin-bottom-1x bold error-color">
                                            {this.message()}
                                        </Grid>
                                    </Grid>
                                    <Grid container item xs={12} className={`margin-bottom-2x gray-text padding-top ${classes.alignCenter}`}>
                                        {!passportAdded
                                            ? (
                                                <Button
                                                    variant="contained"
                                                    className=""
                                                    onClick={handleSubscriptionRenewal}
                                                >
                                                    Renew {`${isActive ? 'Early' : ''}`}
                                                </Button>
                                            )
                                            : (
                                                <Button
                                                    className="buttonHDSecondary"
                                                    onClick={this.handleCheckout}
                                                >
                                                    Go To Checkout
                                                </Button>
                                            )}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
            </>
        );
    }
}

DesktopPassport.defaultProps = {
    history: {},
    userProfile: {},
    featureFlags: {},
    cartData: {},
    orderData: {},
};

DesktopPassport.propTypes = {
    classes: object.isRequired,
    userProfile: shape({
        userRole: string.isRequired,
        email: string.isRequired,
        XAtt4: string.isRequired,
        XAtt5: string.isRequired,
    }),
    featureFlags: object,
    history: object,
    orderData: shape({
        orderId: string,
    }),
    cartData: shape({
        orderDetails: shape({
            fdOrderVO: shape({
                recipients: arrayOf(shape({
                    orderItems: arrayOf(shape({
                        catalogEntryVO: shape({
                            primeFreeShipFlag: string,
                        }),
                    })),
                })),
            }),
        }),
    }),
    handleSubscriptionRenewal: func.isRequired,
};

export default withRouter(withStyles(styles)(DesktopPassport));
